import WorkIm from '../assets/projects/1.png'
import RealEst from '../assets/projects/2.png'
import code from '../assets/projects/3.png'
import club from '../assets/projects/4.png'
import news from '../assets/projects/5.png'
import cn from '../assets/projects/CN.png'


export const data=[
    {
        id:1,
        name:"Career Network",
        image:cn, 
        github:"https://github.com/SHAON1028/Resale-client",
        live:"https://career-network-76558.web.app/"
    },
    {
        id:2,
        name:"Bike Frenzy",
        image:WorkIm,
        details:"/details_One",
        github:"https://github.com/SHAON1028/Resale-client",
        live:"https://resale-vehicle.web.app",
    },
    {
        id:3,
        name:"Travel G",
        image:RealEst,
        details:"/travel",
        github:"https://github.com/SHAON1028/Service-review",
        live:"https://travel-guides-d15f4.web.app/"
    },
    {
        id:4,
        name:"Code Verse",
        image:code,

        details:"/codeverse",
        github:"https://github.com/programming-hero-web-course1/b610-learning-platform-client-side-SHAON1028",
        live:"https://web-grasp.web.app/",
    },

   


]